import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import {
  Actions,
  Getters,
  Mutations,
  CoinHistoryState,
} from '@/interfaces/store/coinHistory'
import { RootState } from '@/interfaces/store/root'

export const state: CoinHistoryState = {
  isModalActive: false,
  isModalCalendar: false,
  selectedMonth: 0,
  months: []
}

export const getters: GetterTree<CoinHistoryState, RootState> & Getters = {}
export const actions: ActionTree<CoinHistoryState, RootState> & Actions = {
  onOpen({ commit }) {
    commit('updateModalActive', true)
  },
  onClose({ commit }) {
    commit('updateModalActive', false)
  },
  onOpenCalendar({ commit }) {
    commit('updateModalCalendarActive', true)
  },
  onCloseCalendar({ commit }) {
    commit('updateModalCalendarClose', false)
  },
}

export const mutations: MutationTree<CoinHistoryState> & Mutations = {
  updateModalActive(state: CoinHistoryState, isModalActive: boolean) {
    state.isModalActive = isModalActive
  },
  updateModalClose(state: CoinHistoryState, isModalClose: boolean) {
    state.isModalActive = isModalClose
  },
  updateModalCalendarActive(state: CoinHistoryState, isModalActive: boolean) {
    state.isModalCalendar = isModalActive
  },
  updateModalCalendarClose(state: CoinHistoryState, isModalClose: boolean) {
    state.isModalCalendar = isModalClose
  },
  updateSelectedCalendar(state: CoinHistoryState, selectedMonth: number) {
    state.selectedMonth = selectedMonth
  },
  updateCalendar(state: CoinHistoryState, list: string[]) {
    state.months = list
  },
}

export const store: Module<CoinHistoryState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
